import { Component, Input } from '@angular/core';
import { AuthService } from '../../providers/dbservice/authservice';

import { NavController, PopoverController } from 'ionic-angular';
import { Observable } from 'rxjs/Observable';
import { Member } from '../../models/interfaces/member.model';
import { HomePage } from '../../pages/home/home';
import { LoginPage } from '../../pages/login/login';
import { MemberViewPage } from '../../pages/member/member_view';
import { ConfigService } from "../../providers/dbservice/configservice";
import { SubMenuComponent } from '../../components/submenucomponent/submenucomponent';

@Component({
  selector: 'headercomponent',
  templateUrl: 'headercomponent.html'
})
export class HeaderComponent {

  @Input() exportViewName: string;
  @Input() exportFileName: string;
  @Input() hasexportAccess: boolean;
  @Input() hlrunno: string;
  @Input() chapter: string;

  private isSubMenuVisible: boolean = false;
  private headerName: string;
  private styleName: string ="";

  currentUser: Observable<Member>;
  member: Member;
  constructor(private authService: AuthService, public navCtrl: NavController, private popoverCtrl: PopoverController, 
    private configService: ConfigService) {
    console.log("HeaderComponent constructor");
    this.styleName=this.configService.getConfig("STYLENAME");
   

    if (this.authService.currentUser ) {
      this.authService.currentUser.subscribe(
        user => {
          this.currentUser = user;
        });
    }
  }

  private ngOnInit() {
    console.log("HeaderComponent ngOnInit exportViewName: " && this.exportViewName);
    this.headerName=this.configService.getConfig("APPLICATION");
    // ngOnInit required for @Input to be available
    if (this.exportViewName !== undefined && this.hasexportAccess){
      this.isSubMenuVisible = true;
    }
  }

  private doLogout(): any {
    console.log("HeaderComponent doLogout");
    this.authService.doLogout();
    this.navCtrl.setRoot(HomePage);
  }

  private doLogin(): any {
    console.log("HeaderComponent doLogin");
    this.navCtrl.push(LoginPage);
  }

  private viewMember(member: Member) {
    console.log("HeaderComponent viewMember");
    this.navCtrl.push(MemberViewPage, {
      member: member
    });
  }

  private presentPopover(event) {
    console.log("HeaderComponent presentPopover");
    let popover = this.popoverCtrl.create(SubMenuComponent, {"sqlviewname": this.exportViewName, "exportFileName": this.exportFileName, "hasexportAccess": this.hasexportAccess, "hlrunno": this.hlrunno});
    
    popover.present({
       "ev": event,
    });
   
  }

}



// WEBPACK FOOTER //
// ./src/components/headercomponent/headercomponent.ts